import { ShapeUnitRawDescription } from './shapes';

export type DesignSet = {
    [Key in string]?: ShapeUnitRawDescription;
};

export * from './shapes';
